import axios from 'axios';
import URLS from '../util/urls.js';

const state = {
  imoveisListados: [],
  imovelPesquisa: {
    status: "DISPONIVEL",
    categoria: undefined,
    tipoImovel: { id: 0 },
    operacao: "VENDA",
    valorInicial: undefined,
    valorFinal: undefined,
    area: undefined,
    quartos: undefined,
    suites: undefined,
    idNaImobiliaria: undefined,
    endereco: undefined
  },
  imovelSelecionado: {
    id: 0,
    categoria: 'IMOVEL_AVULSO',
    status: "DISPONIVEL",
    operacao: "VENDA",
    posseChave: 'PROPRIETARIO',
    valor: 0,
    tipoImovel: { id: 0 },
    estado: { id: 0 },
    cidade: { id: 0 },
    bairro: { id: 0 },
    proprietariosBeneficiarios: [{}],
    caracteristicasImovel: [],
    caracteristicasCondominio: [],
    captadores: [],
    imagens: [],
    visitas: [],
    placas: [],
    observacoes: []
  },
  logs: [],
  formularios: [],

  clientesDisponiveis: [],
  cidadesDisponiveis: [],
  bairrosDisponiveis: [],
  condominiosDisponiveis: [],
  placasDisponiveis: []
}

const mutations = {
  novoImovel(state) {
    state.imovelSelecionado = {
      id: 0,
      categoria: 'IMOVEL_AVULSO',
      status: "DISPONIVEL",
      operacao: "VENDA",
      posseChave: 'PROPRIETARIO',
      valor: 0,
      tipoImovel: { id: 0 },
      estado: { id: 0 },
      cidade: { id: 0 },
      bairro: { id: 0 },
      proprietariosBeneficiarios: [{}],
      caracteristicasImovel: [],
      caracteristicasCondominio: [],
      captadores: [],
      imagens: [],
      visitas: [],
      placas: [],
      observacoes: []
    };
    state.logs = [];

    state.clientesDisponiveis = [],
    state.cidadesDisponiveis = [];
    state.bairrosDisponiveis = [];
    state.condominiosDisponiveis = [];
    state.placasDisponiveis = [];
  },
  limparImovelPesquisa(state) {
    state.imovelPesquisa = {
      status: "DISPONIVEL",
      categoria: undefined,
      tipoImovel: { id: 0 },
      operacao: "VENDA",
      valorInicial: undefined,
      valorFinal: undefined,
      area: undefined,
      quartos: undefined,
      suites: undefined,
      idNaImobiliaria: undefined,
      endereco: undefined
    }
  },
  limparCidadesDisponiveis(state) {
    state.cidadesDisponiveis = [];
  },
  limparBairrosDisponiveis(state) {
    state.bairrosDisponiveis = [];
  },
  limparPlacasDisponiveis(state) {
    state.placasDisponiveis = [];
  },
  limparImoveisListados(state) {
    state.imoveisListados = [];
  },

  atualizarImoveisListados(state, payload) {
    state.imoveisListados = payload;
  },
  atualizarimovelSelecionado(state, payload) {
    state.imovelSelecionado = payload;
    state.logs = [];

    state.clientesDisponiveis = [payload.proprietariosBeneficiarios[0]];
    state.cidadesDisponiveis = [payload.cidade];
    state.bairrosDisponiveis = [payload.bairro];
    state.condominiosDisponiveis = [payload.condominio];
  },
  duplicarImovel(state, payload) {
    state.imovelSelecionado.id = 0;
    state.imovelSelecionado.idNaImobiliaria = "";
    state.imovelSelecionado.status = "DISPONIVEL";
    state.imovelSelecionado.operacao =  "VENDA";
    state.imovelSelecionado.imagens = [];
    state.imovelSelecionado.visitas = [];
    state.imovelSelecionado.placas =  [];
    state.imovelSelecionado.observacoes = [];
    state.logs = [];
    
    if(!payload.informacoesProprietario) {
      state.proprietariosBeneficiarios = [{}];
      state.clientesDisponiveis = [];
    }

    if(!payload.caracteristicasImovel) {
      state.imovelSelecionado.caracteristicasImovel =  [];
    }

    if(!payload.caracteristicasCondominio) {
      state.imovelSelecionado.caracteristicasCondominio =  [];
    }
    
    if(!payload.captadores) {
      state.imovelSelecionado.captadores = [];
    }

    if(!payload.informacoesAdicionais) {
      state.imovelSelecionado.torres = undefined;
      state.imovelSelecionado.pavimentos = undefined;
      state.imovelSelecionado.elevadores = undefined;
      state.imovelSelecionado.unidadesPorAndar = undefined;

      state.imovelSelecionado.quartos = undefined;
      state.imovelSelecionado.banheiros = undefined;
      state.imovelSelecionado.suites = undefined;
      state.imovelSelecionado.suitesReversiveis = undefined;

      state.imovelSelecionado.garagensCobertas = undefined;
      state.imovelSelecionado.garagensNaoCobertas = undefined;

      state.imovelSelecionado.area = undefined;
      state.imovelSelecionado.dimensoesDoTerreno = undefined;
      state.imovelSelecionado.valorIPTU = undefined;
      state.imovelSelecionado.valorCondominio = undefined;
    }

    if(!payload.outrasInformacoes) {
      state.imovelSelecionado.posseChave = "PROPRIETARIO";
      state.imovelSelecionado.informacoesChave = undefined;
      state.imovelSelecionado.autorizacaoPlaca = "PERMITIDO";
      state.imovelSelecionado.descricao = undefined;
      state.imovelSelecionado.outrasInformacoes = undefined;
      state.imovelSelecionado.estadoConservacao = undefined;
      state.imovelSelecionado.anoConstrucao = undefined;
      state.imovelSelecionado.cartorioDeRegistro = undefined;
      state.imovelSelecionado.matriculaCartorio = undefined;
      state.imovelSelecionado.ocupado = false;
      state.imovelSelecionado.quitado = false;
      state.imovelSelecionado.financiado = false;
      state.imovelSelecionado.financiavel = false;

      state.imovelSelecionado.urlVideo = undefined;
    }

  },
  atualizarLogs(state, payload) {
    state.logs = payload;
  },

  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload;
  },
  atualizarCondominiosDisponiveis(state, payload) {
    state.condominiosDisponiveis = payload;
  },
  atualizarCidadesDisponiveis(state, payload) {
    state.cidadesDisponiveis = payload;
  },
  atualizarBairrosDisponiveis(state, payload) {
    state.bairrosDisponiveis = payload;
  },
  atualizarPlacasDisponiveis(state, payload) {
    state.placasDisponiveis = payload;
  },

  atualizarFormularios(state, payload) {
    state.formularios = payload;
  }
}

const actions = {
  novoImovel(context) {
    context.commit('novoImovel');
  },
  limparImovelPesquisa(context) {
    context.commit('limparImovelPesquisa');
  },
  limparCidadesDisponiveis(context) {
    context.commit('limparCidadesDisponiveis');
  },
  limparBairrosDisponiveis(context) {
    context.commit('limparBairrosDisponiveis');
  },

  listarImoveis(context, payload) {
    return axios.post(URLS.IMOVEIS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarImoveisListados', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarImoveis', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      context.commit('limparImoveisListados')
      throw error;
    });
  },
  recuperarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      context.dispatch('novoImovel');
      throw error;
    });
  },
  gravarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.dispatch('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.dispatch('novoImovel');
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  disponibilizarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_DISPONIBILIZAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('disponibilizarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  indisponibilizarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_INDISPONIBILIZAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('indisponibilizarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  arquivarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_ARQUIVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('arquivarImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  duplicarImovel(context, payload) {
    context.commit('duplicarImovel', payload);
  },

  //SELECTS
  recuperarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarCondominios(context, payload) {
    return axios.post(URLS.CONDOMINIOS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCondominiosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarCondominios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarCidades(context, payload) {
    return axios.post(URLS.CIDADES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCidadesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarCidades', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarBairros(context, payload) {
    return axios.post(URLS.BAIRROS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarBairrosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarBairros', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //VISITAS
  recuperarVisita(context, payload) {
    return axios.post(URLS.IMOVEIS_RECUPERAR_VISITA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarVisita', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gravarVisitaImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_GRAVAR_VISITA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarVisitaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerVisitaImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_REMOVER_VISITA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerVisitaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarRelatorioVisita(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarRelatorioVisita', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  
  // PLACAS
  recuperarPlacas(context, payload) {
    return axios.post(URLS.PLACAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarPlacasDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarPlacas', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gravarPlacaNoImovel(context, payload) {
    return axios.post(URLS.PLACAS_GRAVAR_PLACA_NO_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarPlacaNoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerPlacaImovel(context, payload) {
    return axios.post(URLS.PLACAS_REMOVER_PLACA_DO_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerPlacaImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //OBSERVACOES
  recuperarObservacaoImovel(context, payload) {
    return axios.post(URLS.OBSERVACOES_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarObservacaoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarObservacaoImovel(context, payload) {
    return axios.post(URLS.OBSERVACOES_GRAVAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarObservacaoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerObservacaoImovel(context, payload) {
    return axios.post(URLS.OBSERVACOES_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerObservacaoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gerarRelatorioObservacoesImovel(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('gerarRelatorioObservacoesImovel', payload);
              }
            }).catch((error) => {
              throw error;
            });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  //FORMULÁRIOS
  recuperarFormularios(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarFormularios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  recuperarPerguntasFormulario(context, payload) {
    return axios.post(URLS.FORMULARIOS_RECUPERAR_PERGUNTAS, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarPerguntasFormulario', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  gerarFormularioImovel(context, payload) {
    return axios.post(URLS.FORMULARIOS_GERAR, payload)
    .then(response => {
      return response;
    }).catch((error) => {
      throw error;
    })
  },
  criarDiretorioImovel(context, payload) {
    return axios.post(URLS.FORMULARIOS_CRIAR_DIRETORIO, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('criarDiretorioImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerDiretorioFormularios(context, payload) {
    return axios.post(URLS.FORMULARIOS_REMOVER_DIRETORIO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarFormularios', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerDiretorioFormularios', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  //ARQUIVOS
  uploadArquivoImovel(context, payload) {
    return axios.post(URLS.ARQUIVOS_UPLOAD, payload, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('uploadArquivoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  removerArquivoImovel(context, payload) {
    return axios.post(URLS.ARQUIVOS_REMOVER, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerArquivoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  
  //RESERVAS
  reservarImovel(context, payload) {
    return axios.post(URLS.IMOVEIS_RESERVAR_IMOVEL, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('reservarImovel', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerArquivoImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  desfazerReserva(context, payload) {
    return axios.post(URLS.IMOVEIS_DESFAZER_RESERVA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarimovelSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('desfazerReserva', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //LOGS
  recuperarLogsImovel(context, payload) {
    return axios.post(URLS.LOGGER_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLogs', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarLogsImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  //RELATORIOS
  gerarRelatoriosImovel(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gerarRelatoriosImovel', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  enviarRelatoriosImovelPorEmail(context, payload) {
    return axios.post(URLS.RELATORIOS_ENVIAR_POR_EMAIL, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
            .then(authResponse => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('enviarRelatoriosImovelPorEmail', payload);
              }
            }).catch((error) => {
              throw error;
            });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  }
}

export default {
  state,
  mutations,
  actions
}